import { useCallback } from 'react';
import { useAtom } from 'jotai';
import { type PendingPolygonReviewT, pendingPolygonReviewAtom } from '../../../labelling-v2/atoms/tool-atoms';
export const usePendingPolygonReview = () => {
  const [pendingPolygonReview, setPendingPolygonReview] = useAtom(pendingPolygonReviewAtom);
  const setPendingReview = useCallback((review: PendingPolygonReviewT) => {
    setPendingPolygonReview(review);
  }, [setPendingPolygonReview]);
  const clearPendingReview = useCallback(() => {
    setPendingPolygonReview(null);
  }, [setPendingPolygonReview]);
  return {
    pendingPolygonReview,
    setPendingReview,
    clearPendingReview
  };
};